module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "btn",
    staticClass: "btn",
    class: _vm.type,
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom"
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.icon) ? _c('icon', {
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cc68272!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/vuestrap/IconBtn.vue
// module id = 1529
// module chunks = 2